/**
 * @file: useMostAppropriateInspectionTemplate.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useCurrentUser } from '@euler/app/flows/auth/context';
import { InspectionTemplate } from '@euler/model';

export const useMostAppropriateInspectionTemplate = (
  templates: InspectionTemplate[],
) => {
  const {
    org: { id: orgId, agentId },
    store: { id: storeId },
  } = useCurrentUser()!;
  return (
    templates.find(x => x.storeId === storeId && x.orgId === orgId) ??
    templates.find(x => x.orgId === orgId && !x.storeId) ??
    templates.find(x => agentId != null && x.agentId === agentId) ??
    templates.find(x => !x.orgId && !x.storeId)
  );
};
